import type { PasswordChangeStatus } from '@rp/contracts'

export type AuthUser = { id: string; email: string | null; displayName: string }

export const AUTH_ERROR_KINDS = ['invalid_credentials', 'weak_password', 'too_many_attempts', 'network', 'unknown'] as const
export type AuthErrorKind = (typeof AUTH_ERROR_KINDS)[number]

export class AuthClientError extends Error {
  readonly kind: AuthErrorKind

  constructor(kind: AuthErrorKind, message: string, options: { cause?: unknown } = {}) {
    super(message, options.cause === undefined ? undefined : { cause: options.cause })
    this.name = 'AuthClientError'
    this.kind = kind
  }
}

export interface AuthClient {
  subscribe(listener: (user: AuthUser | null) => void, onRestoreFailure?: (error: AuthClientError) => void): () => void
  retryRestore(): void
  current(): AuthUser | null
  signIn(email: string, password: string): Promise<AuthUser>
  signOut(): Promise<void>
  forget(): void
  changePassword(currentPassword: string, newPassword: string): Promise<PasswordChangeStatus>
}
